import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const CustomDivider = ({ hasMargin = true }) => {
    return (
        <div
            className={clsx(
                'w-full h-px bg-grayLines',
                hasMargin ? 'my-4' : 'my-0',
            )}
        />
    )
}

CustomDivider.propTypes = {
    hasMargin: PropTypes.bool,
}

export default CustomDivider
